import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";
import { Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import GetProfile from "../../Api/Speakers/Profile/GetProfile";

const News = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const { user, userId } = useAuth();
  toast.dismiss();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [newsList, setNewsList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(12);
  const [totalPages, setTotalPages] = useState(0);
  const [newsTypeId, setNewsTypeId] = useState(null);
  const [keyword, setKeyword] = useState("");

  const fetchNews = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/users/news", {
        params: {
          pageNumber,
          pageSize,
          NewsTypeId: newsTypeId,
          keywords: keyword,
        },
      });

      const { items, metadata } = response.data;

      const mappedNews = items.map((item) => ({
        id: item.id,
        imgSrc: item.thumbnailImagePath,
        alt: i18n.language === "ar" ? item.arabicTitle : item.englishTitle,
        date: new Date(item.createdOn).toLocaleDateString("ar-EG"),
        title: i18n.language === "ar" ? item.arabicTitle : item.englishTitle,
        description:
          i18n.language === "ar"
            ? item.arabicDescription
            : item.englishDescription,
        badge: {
          text:
            i18n.language === "ar"
              ? item.newsType?.arabicName
              : item.newsType?.englishName,
          className: "bg-primary text-white",
        },
        views: item.viewCount,
      }));

      setNewsList(mappedNews);
      setTotalPages(metadata.totalPages);
    } catch (error) {
      console.error("فشل تحميل الأخبار:", error);
    }
  };

  useEffect(() => {
    fetchNews();
  }, [pageNumber, newsTypeId, keyword]);

  const handleSearchChange = (e) => {
    setKeyword(e.target.value);
    setPageNumber(1);
  };

  const handleNewsTypeChange = (typeId) => {
    setNewsTypeId(typeId);
    setPageNumber(1);
  };

  const goToNextPage = () => {
    if (pageNumber < totalPages) setPageNumber(pageNumber + 1);
  };

  const goToPrevPage = () => {
    if (pageNumber > 1) setPageNumber(pageNumber - 1);
  };

  return (
    <div dir={languageDirection}>
      <section
        className="bg-light position-relative overflow-hidden"
        style={{ "--bs-bg-opacity": 0.8 }}
      >
        {/* الزخارف - أعلى اليسار */}
        <div
          className="position-absolute top-0 start-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="180" height="180" viewBox="0 0 200 200">
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(0, 0)"
            />
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(80, 80)"
            />
          </svg>
        </div>

        {/* الزخارف - أسفل اليمين */}
        <div
          className="position-absolute bottom-0 end-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="150" height="150" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="50" fill="#6B72E0" />
            <circle cx="50" cy="50" r="35" fill="#ffffff" />
            <circle cx="50" cy="50" r="20" fill="#6B72E0" />
          </svg>
        </div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center" data-aos="fade-up">
              <div
                className="d-inline-flex justify-content-center align-items-center bg-primary-custom rounded-circle mb-3"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fas fa-newspaper fa-lg text-white"></i>
              </div>
              <h1 className="fw-bold text-primary-custom mb-3">
                {t("news_title")}
              </h1>
              <p className="lead mb-4">{t("news_description")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* سكشن المحتوى */}
      <section className="py-5">
        <div className="container news-container">
          <div className="row">
            {newsList.map(
              ({ id, imgSrc, alt, date, title, description, badge, views }) => (
                <div key={id} className="col-lg-4 col-md-6 mb-4">
                  <div
                    className="news-card card h-100 shadow-sm"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={imgSrc}
                      className="card-img-top"
                      alt={alt}
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="card-body">
                      <div className="news-meta mb-2">
                        <small className="text-muted">
                          <i className="fas fa-calendar-alt me-1"></i>
                          {date}
                        </small>
                      </div>
                      <h5 className="card-title">{title}</h5>
                      <p className="card-text">{description}</p>
                      <div className="news-footer d-flex justify-content-between align-items-center">
                        {badge ? (
                          <span className={`badge ${badge.className}`}>
                            {badge.text}
                          </span>
                        ) : null}

                        <small className="text-muted">
                          <i className="fas fa-eye me-1"></i>
                          {views}
                        </small>
                      </div>
                    </div>
                    <Link
                      to={`/news-detail/${id}`}
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-arrow-right me-2"></i>
                      {t("news.detail")}
                    </Link>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default News;
